module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/contracts-balance/contracts-processing-file/contracts-processing-file.component.css
// module id = 988
// module chunks = 7